{
	"closes": "Chiusura: {{date}}",
	"columns": {
		"applications": "Domande inviate",
		"call": "Bando",
		"dsu_quota": "Quota DSU",
		"flags": "Segnalazioni",
		"intake": "Domande dirette",
		"offers": "Offerte",
		"ranking": "Graduatoria",
		"reminder": "Sollecito",
		"residence": "Struttura"
	},
	"dsu_quota": {
		"below_threshold": "Sotto soglia",
		"figures": "{{seats}}/{{threshold}}",
		"no_threshold": "{{seats}}, dato mancante"
	},
	"empty": "Nessun bando pubblicato.",
	"empty_filtered": "Nessun bando corrisponde ai filtri.",
	"filters": {
		"academic_year": "Anno accademico",
		"state": "Stato del bando"
	},
	"flags": {
		"count_one": "{{count}} aperta",
		"count_other": "{{count}} aperte",
		"none": "Nessuna"
	},
	"intake": {
		"closed": "Chiuso",
		"declared": "Dal gestore, {{date}}",
		"expired": "Alla scadenza",
		"not_started": "Non ancora aperto",
		"open": "Aperto"
	},
	"late": "In ritardo",
	"never": "Mai sollecitata",
	"offers": {
		"accepted_one": "{{count}} accettata",
		"accepted_other": "{{count}} accettate",
		"none": "Non avviate",
		"overdue_one": "{{count}} oltre il termine del gestore",
		"overdue_other": "{{count}} oltre il termine del gestore",
		"waiting_one": "{{count}} in attesa",
		"waiting_other": "{{count}} in attesa"
	},
	"other_year": "Solo bando in corso",
	"page_title": "Bandi",
	"ranking_none": "Nessun calcolo",
	"remind": {
		"command": "Sollecita",
		"confirm": "Invia il sollecito",
		"description": "Scriviamo a ogni gestore attivo della struttura un'email con le attività in attesa della sua prima pagina e le scadenze. Il promemoria non cambia nessun esito.",
		"nothing": "La struttura non ha attività in attesa: nessun sollecito inviato.",
		"sent_one": "Sollecito inviato a {{count}} gestore",
		"sent_other": "Sollecito inviato a {{count}} gestori",
		"title": "Sollecitare i gestori della struttura {{residence}}?"
	},
	"reminded": "{{date}}",
	"reminded_by": "{{date}}, da {{name}}",
	"search_placeholder": "Cerca una struttura",
	"until": "Entro il {{date}}"
}
